(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fn-v2-use"] && !Shopify.designMode) return;
  try {
    
function initFranarineCosts(root=document){root.querySelectorAll('[data-fn-cost]').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='true';const length=box.querySelector('[data-fn-length]');const strips=box.querySelector('[data-fn-strips]');const yieldOutput=box.querySelector('[data-fn-yield]');const estimate=box.querySelector('[data-fn-estimate]');function update(){const amount=Math.floor(Number(strips.value));if(!Number.isFinite(amount)||amount<1||amount>1000){strips.setAttribute('aria-invalid','true');yieldOutput.textContent='—';estimate.textContent='—';return}strips.removeAttribute('aria-invalid');const perRoll=Math.floor(Number(box.dataset.rollLength)/Number(length.value));const rolls=Math.ceil(amount/perRoll);const cents=Number(box.dataset.rollPrice);yieldOutput.textContent=String(perRoll);const cost=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:box.dataset.currency}).format(rolls*cents/100);estimate.textContent=box.dataset.rollCountLabel.replace('[count]',String(rolls))+(cents>0?' · '+box.dataset.costLabel.replace('[cost]',cost):'')}length.addEventListener('change',update);strips.addEventListener('input',update);update()})}initFranarineCosts();document.addEventListener('shopify:section:load',event=>initFranarineCosts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-v3-use"] && !Shopify.designMode) return;
  try {
    
function initFranarineCosts(root=document){root.querySelectorAll('[data-fn-cost]').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='true';const length=box.querySelector('[data-fn-length]');const strips=box.querySelector('[data-fn-strips]');const yieldOutput=box.querySelector('[data-fn-yield]');const estimate=box.querySelector('[data-fn-estimate]');function update(){const amount=Math.floor(Number(strips.value));if(!Number.isFinite(amount)||amount<1||amount>1000){strips.setAttribute('aria-invalid','true');yieldOutput.textContent='—';estimate.textContent='—';return}strips.removeAttribute('aria-invalid');const perRoll=Math.floor(Number(box.dataset.rollLength)/Number(length.value));const rolls=Math.ceil(amount/perRoll);const cents=Number(box.dataset.rollPrice);yieldOutput.textContent=String(perRoll);const cost=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:box.dataset.currency}).format(rolls*cents/100);estimate.textContent=box.dataset.rollCountLabel.replace('[count]',String(rolls))+(cents>0?' · '+box.dataset.costLabel.replace('[cost]',cost):'')}length.addEventListener('change',update);strips.addEventListener('input',update);update()})}initFranarineCosts();document.addEventListener('shopify:section:load',event=>initFranarineCosts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jm-review-wall'))customElements.define('jm-review-wall',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.addEventListener('click',e=>{if(e.target.closest('[data-jm-more]')){this.querySelectorAll('[data-jm-extra]').forEach(c=>c.hidden=false);e.target.closest('[data-jm-more]').hidden=true}if(e.target.closest('[data-jm-compose]'))this.querySelector('dialog').showModal();if(e.target.closest('[data-jm-close]'))this.querySelector('dialog').close()},{signal});document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.jm-review-card');if(card&&this.contains(card))card.hidden=false},{signal})}disconnectedCallback(){this.abort?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scar-product-landing-v3"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('scar-product-v3'))customElements.define('scar-product-v3',class extends HTMLElement{
 connectedCallback(){if(this.abort)this.abort.abort();this.abort=new AbortController();const signal=this.abort.signal;const source=this.querySelector('[data-plp-variants]');if(!source)return;let variants;try{variants=JSON.parse(source.textContent)}catch(_){return}const select=this.querySelector('[data-plp-variant]');const quantity=this.querySelector('[data-plp-quantity]');const update=()=>{const variant=variants.find(v=>String(v.id)===select.value);if(!variant)return;this.querySelectorAll('[name="id"]').forEach(input=>{input.value=String(variant.id);input.dispatchEvent(new Event('change',{bubbles:true}))});const price=new Intl.NumberFormat(this.dataset.locale||'en-US',{style:'currency',currency:this.dataset.currency,currencyDisplay:'code'}).format(variant.price/100);this.querySelectorAll('[data-plp-price]').forEach(x=>x.textContent=price);const submit=this.querySelector('[name="add"]');if(submit){submit.disabled=!variant.available;submit.toggleAttribute('data-unavailable',!variant.available);const label=submit.querySelector('.main-atc__label__text,[data-plp-add-text]');if(label)label.textContent=variant.available?this.dataset.addLabel:this.dataset.soldLabel;}if(quantity&&variant.quantity_rule){quantity.min=variant.quantity_rule.min||1;quantity.step=variant.quantity_rule.increment||1;}const url=new URL(window.location.href);url.searchParams.set('variant',String(variant.id));window.history.replaceState({},'',url.toString());};select.addEventListener('change',update,{signal});
 }
 disconnectedCallback(){if(this.abort)this.abort.abort()}
});

// Card selection delegates to the existing variant select and its original change handler.
if(!customElements.get('scar-pack-cards'))customElements.define('scar-pack-cards',class extends HTMLElement{
 connectedCallback(){if(this.packAbort)this.packAbort.abort();this.packAbort=new AbortController();const signal=this.packAbort.signal;const root=this.closest('scar-product-v3');const select=root&&root.querySelector('[data-plp-variant]');if(!select)return;let variants=[];try{variants=JSON.parse(root.querySelector('[data-plp-variants]').textContent)}catch(_){return}
 const sync=()=>{const variant=variants.find(v=>String(v.id)===select.value);if(!variant)return;this.querySelectorAll('input[type="radio"]').forEach(input=>{const item=variants.find(v=>String(v.id)===input.value);input.checked=input.value===select.value;if(item)input.disabled=!item.available});const radio=this.querySelector('input:checked');const card=radio&&radio.closest('[data-pack-count]');const count=card&&Number(card.dataset.packCount);const status=this.querySelector('[data-pack-status]');if(status)status.textContent=(count?count+(count===1?' roll':' rolls'):'Selected pack')+' · '+(variant.available?'Available':'Unavailable');};
 this.addEventListener('change',event=>{const input=event.target;if(!input.matches('input[type="radio"]')||!input.checked||input.disabled)return;select.value=input.value;select.dispatchEvent(new Event('change',{bubbles:true}));},{signal});select.addEventListener('change',sync,{signal});sync();
 }
 disconnectedCallback(){if(this.packAbort)this.packAbort.abort()}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scar-v5-compact-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('scar-v5-review-carousel'))customElements.define('scar-v5-review-carousel',class extends HTMLElement{
connectedCallback(){
this.controller?.abort();clearInterval(this.timer);this.controller=new AbortController();const signal=this.controller.signal;
const track=this.querySelector('.v5-review-track'),cards=[...this.querySelectorAll('.v5-review-card')],nav=this.querySelector('.v5-review-nav'),count=this.querySelector('[data-review-count]'),toggle=this.querySelector('[data-review-toggle]');if(!track||!cards.length)return;
nav.hidden=cards.length<2;this.paused=false;this.inView=false;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
const index=()=>{let i=0,d=Infinity;cards.forEach((c,n)=>{const v=Math.abs(c.getBoundingClientRect().left-track.getBoundingClientRect().left-3);if(v<d){d=v;i=n;}});return i;};
const go=n=>{const c=cards[(n+cards.length)%cards.length];track.scrollBy({left:c.getBoundingClientRect().left-track.getBoundingClientRect().left-3,behavior:this.reduced.matches?'auto':'smooth'});};
const stop=()=>{clearInterval(this.timer);this.timer=null;};
const start=()=>{stop();if(this.dataset.autoplay!=='true'||this.dataset.editor==='true'||this.paused||!this.inView||this.reduced.matches||document.hidden||cards.length<2||this.matches(':hover')||this.contains(document.activeElement))return;this.timer=setInterval(()=>go(index()+1),Math.max(1000,Number(this.dataset.interval)||1000));};
const pause=()=>{this.paused=true;toggle.textContent='▶';toggle.setAttribute('aria-label','Play automatic reviews');toggle.setAttribute('aria-pressed','true');stop();};
this.querySelector('[data-review-prev]').addEventListener('click',()=>{pause();go(index()-1);},{signal});
this.querySelector('[data-review-next]').addEventListener('click',()=>{pause();go(index()+1);},{signal});
toggle.addEventListener('click',()=>{if(this.paused){this.paused=false;toggle.textContent='Ⅱ';toggle.setAttribute('aria-label','Pause automatic reviews');toggle.setAttribute('aria-pressed','false');}else pause();start();},{signal});
track.addEventListener('scroll',()=>count.textContent=(index()+1)+' / '+cards.length,{signal,passive:true});
track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();pause();go(index()+(e.key==='ArrowRight'?1:-1));}},{signal});
this.addEventListener('pointerenter',stop,{signal});this.addEventListener('pointerleave',start,{signal});this.addEventListener('focusin',stop,{signal});this.addEventListener('focusout',()=>setTimeout(start,0),{signal});track.addEventListener('touchstart',pause,{signal,passive:true});
document.addEventListener('visibilitychange',start,{signal});this.reduced.addEventListener('change',start,{signal});
this.observer?.disconnect();this.observer=new IntersectionObserver(e=>{this.inView=e[0].isIntersecting;start();},{threshold:.2});this.observer.observe(this);
document.addEventListener('shopify:block:select',e=>{const i=cards.findIndex(c=>c===e.target||c.contains(e.target));if(i>=0){pause();go(i);}},{signal});
toggle.hidden=this.dataset.autoplay!=='true'||cards.length<2;count.textContent='1 / '+cards.length;
}
disconnectedCallback(){this.controller?.abort();clearInterval(this.timer);this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scar-v5-sticky-purchase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('scar-v5-sticky-buy'))customElements.define('scar-v5-sticky-buy',class extends HTMLElement{
connectedCallback(){
 this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
 this.root=document.querySelector('#V5Supply')?.closest('scar-product-v5');if(!this.root)return;
 const source=this.root.querySelector('[data-plp-variant]'),target=this.querySelector('[data-sticky-variant]'),button=this.querySelector('[data-sticky-buy]'),price=this.querySelector('[data-sticky-price]'),error=this.querySelector('[data-sticky-error]');if(!source||!target||!button)return;
 let variants=[];try{variants=JSON.parse(this.root.querySelector('[data-plp-variants]').textContent);}catch(e){return;}
 const originalLabel=button.textContent;target.replaceChildren(...[...source.options].map(o=>{const opt=document.createElement('option');opt.value=o.value;opt.textContent=o.textContent;const v=variants.find(v=>String(v.id)===o.value);opt.disabled=!v?.available;return opt;}));
 const nativeCard=()=>this.root.querySelector('#opc-override-dyn-c-btn');
 const sync=()=>{target.value=source.value;const v=variants.find(v=>String(v.id)===source.value);if(!v)return;this.root.querySelectorAll('input[name="id"]').forEach(field=>{if(field.value!==String(v.id)){field.value=String(v.id);field.setAttribute('value',String(v.id));field.dispatchEvent(new Event('change',{bubbles:true}));}});price.textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:this.dataset.currency||'USD'}).format(v.price/100);const original=nativeCard();button.disabled=!v.available||!original||original.disabled;button.textContent=v.available?originalLabel:this.dataset.unavailable;};
 target.addEventListener('change',()=>{source.value=target.value;source.dispatchEvent(new Event('change',{bubbles:true}));sync();},{signal});source.addEventListener('change',sync,{signal});this.root.addEventListener('change',sync,{signal});
 button.addEventListener('click',()=>{sync();if(button.disabled)return;const original=nativeCard();if(!original)return;error.hidden=true;try{original.click();}catch(e){error.textContent='Please use the payment options in the purchase section.';error.hidden=false;}},{signal});
 const visibility=()=>{const preview=document.querySelector('#PBarNextFrame');const p=preview?.getBoundingClientRect();this.style.bottom=(p&&p.height<120&&p.bottom>0&&p.top<innerHeight?Math.min(100,p.height):0)+'px';const rect=this.root.getBoundingClientRect(),hero=document.querySelector('.v5-hero'),heroPassed=!hero||hero.getBoundingClientRect().bottom<0,purchaseVisible=rect.bottom>0&&rect.top<innerHeight,cartOpen=!!document.querySelector('cart-drawer.active,.cart-drawer.active,cart-drawer[open]');this.hidden=!heroPassed||purchaseVisible||cartOpen;};
 this.updateVisibility=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(visibility);};
 window.addEventListener('scroll',this.updateVisibility,{signal,passive:true});window.addEventListener('resize',this.updateVisibility,{signal});document.addEventListener('visibilitychange',this.updateVisibility,{signal});
 this.mutation=new MutationObserver(()=>{sync();visibility();});this.mutation.observe(this.root,{childList:true,subtree:true});const drawer=document.querySelector('cart-drawer');if(drawer)this.mutation.observe(drawer,{attributes:true,attributeFilter:['class','open']});
 sync();visibility();
}
disconnectedCallback(){this.controller?.abort();this.mutation?.disconnect();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scar-v5-supply-calculator"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('scar-v5-length-estimator'))customElements.define('scar-v5-length-estimator',class extends HTMLElement{
connectedCallback(){if(this.controller)this.controller.abort();this.controller=new AbortController();const input=this.querySelector('input'),output=this.querySelector('[data-estimate-output]');if(!input||!output)return;const update=()=>{const n=Number(input.value);output.textContent=n>0&&n<=300?'One roll provides up to '+Math.floor(300/n)+' fresh '+n+' cm strips.':'Enter a cut length from 1 to 300 cm.';};input.addEventListener('input',update,{signal:this.controller.signal});update();}
disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
